import { api } from './api';

export const fetchComments = (params) => {
  return api.get('/comment', params);
};

export const fetchAddComment = (payload) => {
  return api.post('/comment', payload);
};
